import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class HefteTeacherActivationCode extends MongoEntity {
  static override _class = 'HefteTeacherActivationCode';
  static override _collectionName = 'hefte-teacher-activation-codes';

  @validate(nonOptional())
  @Field(() => String)
  code!: string;

  @Field(() => String)
  usedByTeacherID: Maybe<string>;
}

export async function validateActivationCode(code: string): Promise<boolean> {
  const col = await getRawCollection<EntityData<HefteTeacherActivationCode>>(
    HefteTeacherActivationCode._collectionName,
  );
  const doc = await col.findOne({ code, used: { $ne: true } });
  return doc !== null;
}

export async function ensureActivationCode() {
  const col = await getRawCollection<EntityData<HefteTeacherActivationCode>>(
    HefteTeacherActivationCode._collectionName,
  );
  const existing = await col.findOne({ _id: 'H9K2-L5P1-X7R3-Q8N4' });
  if (!existing) {
    await col.insertOne({
      _id: 'H9K2-L5P1-X7R3-Q8N4',
      _class: HefteTeacherActivationCode._class,
      code: 'H9K2-L5P1-X7R3-Q8N4',
      usedByTeacherID: null,
    });
  }
}
